import { onBeforeUnmount, onMounted, ref } from 'vue';
import CacheManager from '@vue-util/cacheManager';
import useEnvParams from '@composables/useEnvParams';
import useKillSwitches from '@composables/useKillSwitches';
import { ILoyalty } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

const { Cookie, UserStatus } = require('@common-vue/util/src/modules/cookie');

/**
 * Composable for getting the loyalty information from the local storage
 * @returns {ILoyalty}
 */
export default function useLoyaltyBadgeInfo() {
  const { isMcom } = useEnvParams();
  const { loyaltyBadgeEnhancementEnabled } = useKillSwitches();
  const loyaltyBadgeInfo = ref({});
  let userId;

  const handleStorageEvent = () => {
    const loyaltyInfo = CacheManager.getPersistent(`hnfsr_${userId}`) || {};
    loyaltyBadgeInfo.value = loyaltyInfo;
  };

  const removeEventListener = () => {
    window?.removeEventListener('storage', handleStorageEvent);
  };

  onMounted(() => {
    /* istanbul ignore else */
    if (isMcom && UserStatus.isSignedIn() && loyaltyBadgeEnhancementEnabled) {
      userId = Cookie.get('macys_online_uid');
      const loyaltyInfo = CacheManager.getPersistent(`hnfsr_${userId}`);

      if (!loyaltyInfo) {
        window.addEventListener('storage', handleStorageEvent);
      } else {
        loyaltyBadgeInfo.value = loyaltyInfo;
        removeEventListener();
      }
    }
  });

  onBeforeUnmount(() => {
    removeEventListener();
  });

  return loyaltyBadgeInfo;
}
